<template>
  <div>
    <!-- <template v-if="firstTime"> -->
      <div class="list-header half-pixel-bottom-border g-wrap-padding">
        <div class="list-header-main">
          <img class="list-header-cover half-pixel-border" :src="intro.logo" />
          <div>
            <div class="list-header-title g-text-overflow">{{block_info.title}}</div>
            <div class="list-header-type">{{intro.media_type_name}}</div>
          </div>
        </div>
        <div class="flex">
          <div class="list-header-desc text-clamp" catchtap="introClick">
            {{intro.introduction}}
          </div>
          <div v-if="intro_info.user_is_join === 'N'" style="opacity: 0;" class="list-header-join-placeholder">
              <img src="../image/add-white.png"/>
              <span>{{intro.join_btn_txt || '加入'}}</span>
          </div>
        </div>
        <div
          v-if="intro_info.user_is_join === 'N'"
          @click="joinBtnClick"
          class="list-header-join-placeholder list-header-join">
          <img src="../image/add-white.png" />
          <span>{{intro.join_btn_txt || '加入'}}</span>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'list-header',
  props: {
    intro_info: {
      type: Object,
      default: () => ({})
    },
    block_info: {
      type: Object,
      default: () => ({})
    },
    firstTime: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    intro () {
      return this.intro_info || {}
    }
  },
  methods: {
    joinBtnClick () {
      this.$emit('joinBtnClick')
    }
  }
}
</script>

<style lang="less" scoped>
@import url(../mixins.less);

.half-pixel-bottom-border{
  &::before{
    border-color: #E6E6E6;
    z-index: 1;
  }
}

.list-header{
  padding-top: 40 / @ratio;
  padding-bottom: 32 / @ratio;
}

.list-header-main{
  padding-bottom: 28 / @ratio;
  .flex();
}

.list-header-cover{
  .webkitCss(flex, 0 0 auto);
  .square(160 / @ratio);
  overflow: hidden;
  margin-right: 28 / @ratio;
  box-shadow:0 8 / @ratio 24 / @ratio 0 rgba(0,0,0,0.2);
  border-radius:24 / @ratio;
  .webkitCss(object-fit, cover);
  .webkitCss(object-position, center);
  &::before{
    border-radius: 48 /@ratio;
  }
}

.list-header-title{
  width: 462 / @ratio;
  margin-bottom: 10 / @ratio;
  margin-top: 34 / @ratio;
  font-size:40 / @ratio;
  font-weight:bold;
  color:rgba(0,0,0,1);
  line-height:48 / @ratio;
}

.list-header-type{
  font-size:28 / @ratio;
  font-weight:bold;
  color:rgba(171,171,171,1);
  line-height:34 / @ratio;
}

.list-header-desc{
  .webkitCss(flex, 1 1 auto);
  min-height: 88 / @ratio;
  font-size:28 / @ratio;
  color:rgba(102,102,102,1);
  line-height:44 / @ratio;
  -webkit-line-clamp: 2;
}

.list-header-join-placeholder{
  .webkitCss(flex, 0 0 auto);
  .flex();
  .webkitCss(align-items, center);
  height:72 / @ratio;
  padding: 0 36 / @ratio;
  margin-left: 48 / @ratio;
  font-size: 26 / @ratio;
  font-weight: bold;
  color: #fff;
  line-height: 72 / @ratio;
  transition: flex 0.2s;
  overflow: hidden;
  img{
    .square(24 / @ratio);
    margin-right: 8 / @ratio;
  }
}

.list-header-join{
  position: absolute;
  right: 40 / @ratio;
  top: 236 / @ratio;
  z-index: 3;
  width: max-content;
  width: -webkit-max-content;
  background:rgba(59,59,59,1);
  border-radius:12 / @ratio;
  transition: transform 0.3s;
}

</style>
